const numberFormat = new Intl.NumberFormat("en-US", { maximumFractionDigits: 4 });
/** Return a number, or undefined if the number is NaN */
export function numberOrUndefined(maybeNumber) {
    if (isNaN(maybeNumber)) {
        return undefined;
    }
    return maybeNumber;
}
export function formatNumber(number) {
    if (isNaN(number)) {
        return "-";
    }
    return numberFormat.format(number);
}
/**
 * Format a duration in milliseconds to a human-readable string
 *
 * @param duration Duration in milliseconds
 */
export function formatDuration(duration) {
    if (duration < 1000) {
        return `${duration}ms`;
    }
    return `${formatNumber(msToSeconds(duration))}s`;
}
export function abbreviateNumber(number) {
    if (isNaN(number)) {
        return "-";
    }
    if (number >= 1000000000000) {
        return `${round(number / 1000000000000, 1)}T`;
    }
    if (number >= 1000000000) {
        return `${round(number / 1000000000, 1)}B`;
    }
    if (number >= 1000000) {
        return `${round(number / 1000000, 1)}M`;
    }
    if (number >= 1000) {
        return `${round(number / 1000, 1)}K`;
    }
    return String(number);
}
export function numberToRank(number) {
    let suffix = "th";
    if (String(number).endsWith("1")) {
        suffix = "st";
    }
    else if (String(number).endsWith("2")) {
        suffix = "nd";
    }
    else if (String(number).endsWith("3")) {
        suffix = "rd";
    }
    return number + suffix;
}
export function msToSeconds(ms) {
    return round(ms / 1000, 2);
}
export function round(num, precision = 0) {
    return Number(num.toFixed(precision));
}
export function roundToNearest(num, nearest) {
    const inverse = 1.0 / nearest;
    return Math.round(num * inverse) / inverse;
}
export function roundToPrevious(num, previous) {
    return num - (num % previous);
}
export function percentageChange(number1, number2) {
    const diff = number2 - number1;
    if (number1 === 0 && number2 === 0) {
        return 0;
    }
    return Math.round((diff / Math.abs(number1)) * 100);
}
/**
 * Determine how many decimal places a number has been rounded to
 */
export function getDecimalPlaces(value) {
    if (typeof value === "number" && Math.floor(value) !== value) {
        let str = value.toString();
        if (str.indexOf("e") !== -1) {
            // Use Number.toFixed() for scientific notation
            str = value.toFixed(20);
        }
        // Remove trailing zeroes and the decimal point if necessary
        str = str.replace(/\.?0+$/, "");
        if (str.indexOf(".") !== -1) {
            // Count the remaining digits after the decimal point
            return str.split(".")[1].length || 1;
        }
    }
    return 0;
}
